(function(){
  var RITUAL_MAP={
    '15496316387703':'face-yoga-lift-glow-ritual',
    '15496316486007':'hair-yoga-growth-ritual',
    '15496316518775':'ultimate-skin-hair-yoga-ritual'
  };
  var RITUAL_IDS=Object.keys(RITUAL_MAP);
  function replaceOnProductPage(id){
    var slug=RITUAL_MAP[id];
    var url='/pages/book-your-skin-yoga-london-ritual?ritual='+slug;
    function doIt(){
      document.querySelectorAll('form[action="/cart/add"] button[type="submit"],[name="add"],.product-form__submit').forEach(function(b){
        if(b._sy)return;b._sy=true;
        b.textContent='Book This Experience';
        b.style.cssText='background:#0A0A0A!important;color:#fff!important;letter-spacing:2px;text-transform:uppercase;font-family:Jost,sans-serif;font-size:12px;cursor:pointer;width:100%;padding:16px;border:none;';
        b.type='button';
        b.onclick=function(e){e.preventDefault();window.location.href=url;};
      });
    }
    doIt();setTimeout(doIt,300);setTimeout(doIt,800);setTimeout(doIt,2000);
    new MutationObserver(doIt).observe(document.body,{childList:true,subtree:true});
  }
  function hideOnCollection(){
    if(!window.location.pathname.includes('/collections/'))return;
    function doIt(){
      RITUAL_IDS.forEach(function(id){
        var slug=RITUAL_MAP[id];
        document.querySelectorAll('a[href*="'+slug+'"]').forEach(function(link){
          var card=link.closest('.card-wrapper,.product-card-wrapper');
          if(!card)return;
          card.querySelectorAll('button[name="add"],button[type="submit"],.card__btn').forEach(function(b){
            if(b._sy)return;b._sy=true;b.style.display='none';
          });
          if(!card.querySelector('.sy-bb')){
            var a=document.createElement('a');
            a.href='/pages/book-your-skin-yoga-london-ritual?ritual='+slug;
            a.className='sy-bb';
            a.textContent='Book This Experience';
            a.style.cssText='display:block;background:#0A0A0A;color:#fff;text-align:center;padding:13px;font-size:11px;letter-spacing:2px;text-transform:uppercase;text-decoration:none;font-family:sans-serif;margin-top:8px;';
            card.appendChild(a);
          }
        });
      });
    }
    doIt();setTimeout(doIt,500);setTimeout(doIt,1500);
    new MutationObserver(doIt).observe(document.body,{childList:true,subtree:true});
  }
  function init(){
    var path=window.location.pathname.toLowerCase();
    if(path.includes('/products/')){
      if(path.includes('face-yoga-lift'))replaceOnProductPage('15496316387703');
      else if(path.includes('hair-yoga-growth'))replaceOnProductPage('15496316486007');
      else if(path.includes('ultimate-skin'))replaceOnProductPage('15496316518775');
    }
    hideOnCollection();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();